import { render, staticRenderFns } from "./GoalEarnings.vue?vue&type=template&id=02552126&scoped=true&"
import script from "./GoalEarnings.vue?vue&type=script&lang=ts&"
export * from "./GoalEarnings.vue?vue&type=script&lang=ts&"
import style0 from "./GoalEarnings.vue?vue&type=style&index=0&id=02552126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02552126",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
